module.exports = __webpack_public_path__ + "static/media/kiwi-bird.8b47e713.svg";